<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          {{ DAT_TITULOS.nuevo }}
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <br>
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group  col-md-6 ">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbUsuarios" [control]="formulario.get('usuarioAlerta')"
                            [idOpcion]="'usuId'" [id]="'usuarioAlerta'"
                            [label]="'Usuario*'" [opcion]="'descripcion'"
                            formControlName="usuarioAlerta"></app-lfsa-combo-box>
      </div>
      <div class="form-group  col-md-6 ">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbColores" [control]="formulario.get('color')"
                            [idOpcion]="'colorId'" [id]="'color'" [label]="'Color*'"
                            [opcion]="'descripcion'"
                            formControlName="color"></app-lfsa-combo-box>
      </div>
    </div>
    <br>
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>
